import * as React from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import { WhyOrigin } from '../WhyOrigin';
import {
  StretchContainer,
  StretchDigitalAdoptionContainer,
  StretchMidPageCompaignContainer,
  Container,
} from '../Container';
import { FindPlan, FindPlanPure } from '../FindPlan';
import { CardBlockContainer } from '../Card/CardBlockContainer';
import { DigitalAdoptionCampaign } from '../DigitalAdoptionCampaign';
import { MidPageCampaign } from '../MidpageCampaign';
import { SignUpPure } from '../SignUp';
import { ProofPoints } from '../ProofPoints';
import { getExperienceOffer } from '../../utils/utils';
import { mboxes } from '../../consts/mboxes';

export const WhyOriginContainer = styled(Container)`
  padding: 40px 0;
`;

export const ProspectProofPoints = ({ store }) => {
  const prospectContent = getExperienceOffer(mboxes.prospectAbTestMbox);
  const whyOriginContent = getExperienceOffer(mboxes.whyOriginMbox);
  const showProofPoints = !isEmpty(prospectContent);
  return showProofPoints ? (
    <WhyOriginContainer>
      <ProofPoints {...prospectContent} />
    </WhyOriginContainer>
  ) : (
    <WhyOriginContainer className="why-origin-container">
      <WhyOrigin {...(store.content as any).toplightcard} {...whyOriginContent} />
    </WhyOriginContainer>
  );
};

export const ProspectExperience = ({ store, signUp }) => {
  const topCardContent = getExperienceOffer(mboxes.topCardsMbox);
  return (
    <>
      <ProspectProofPoints store={store} />
      {store.content.plan && (
        <StretchContainer>
          <FindPlan
            {...store.content.plan}
            component={FindPlanPure}
            dataComment={'FindPlan'}
            trackingId={'header-banner'}
            trackingLabel={'Show me good energy'}
          />
        </StretchContainer>
      )}
      <CardBlockContainer
        {...store.content.topcard}
        {...topCardContent}
        trackingPrefix="cardTop"
        data-comment="CardTop"
      />
      {store.content.midpagecampaign && (
        <StretchMidPageCompaignContainer>
          <MidPageCampaign {...store.content.midpagecampaign} />
        </StretchMidPageCompaignContainer>
      )}
      {store.content.digitaladoption && (
        <StretchDigitalAdoptionContainer>
          <DigitalAdoptionCampaign {...store.content.digitaladoption} />
        </StretchDigitalAdoptionContainer>
      )}
      {store.content.bottomcard && (
        <CardBlockContainer
          trackingPrefix="cardBottom"
          data-comment="CardBottom"
          {...store.content.bottomcard}
        />
      )}
      <StretchMidPageCompaignContainer>
        <FindPlan
          {...signUp}
          component={SignUpPure}
          dataComment={'SignUp'}
          trackingId={'footer-banner'}
          trackingLabel={'See energy plans'}
        />
      </StretchMidPageCompaignContainer>
    </>
  );
};
